import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Paragraph } from 'components/patterns'
import { TextArea } from 'components/deprecated/Inputs'

export const NotesTitle = styled.div`
  display: flex;
  flex-direction: column;
  color: ${themeColor('black')};
`

export const TemplateName = styled(Paragraph)`
  font-size: 20px;
  color: ${themeColor('black')};
`

export const Description = styled(Paragraph)`
  margin-bottom: 15px;
  color: ${themeColor('blackPrimary')};
`

export const StyledFragmentList = styled.div`
  font-size: 14px;
  text-align: left;
  color: ${themeColor('blackPrimary')};
  width: 100%;
`

export const StyledData = styled.span`
  font-size: 14px;
  text-align: left;
  color: ${themeColor('blackPrimary')};
`

export const TextInputContainer = styled.div`
  position: absolute;
  width: 500px;
  height: 75px;
`

export const StyledParagraphThree = styled(Paragraph)``

export const StyledTextArea = styled(TextArea)`
  textarea.ant-input {
    height: 150px;
    min-height: 150px;
    width: 600px !important;
  }
  .input-footer.input-footer {
    margin-left: 570px;
  }
`

export const FragmentListTitle = styled.span`
  font-weight: bold;
`

export const FragmentListData = styled.span`
  margin-right: 10px;
`

export const RoudedTagItem = styled.img`
  width: 70px;
  height: 17px;
`
export const FragmentValueFlexWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
